import { render } from "./AuditTrail.vue?vue&type=template&id=36c2403f&scoped=true"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"

import "./AuditTrail.vue?vue&type=style&index=0&id=36c2403f&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c2403f"]])

export default __exports__